import cn from 'classnames'
import Tooltip from 'antd/lib/tooltip'
import MaterialIcon from '../../../MaterialIcon'
import { useTheme } from '../../../ThemeProvider/ThemeProvider'
import { openSupportChat } from '../../../../../constants/help'
import styles from './HelpButton.module.scss'

/**
 * Pinned to the bottom of the project rail, below the divider, so it stays put
 * however far the projects list above it scrolls.
 */
const HelpButton = () => {
  const { themeMode } = useTheme()

  return (
    <Tooltip placement='right' title='Help'>
      <button
        type='button'
        data-testid='rail-help'
        aria-label='Help'
        className={cn(styles.helpButton, styles[themeMode])}
        onClick={openSupportChat}
      >
        <MaterialIcon outlined name='help_outline' />
      </button>
    </Tooltip>
  )
}

export default HelpButton
